import React from "react";
import "./Footer";
//import htfooterlogo from '../Components/Assets/heartintechlogo.png';
{/* const Footer = () => {
  return (
    <div className="footer ">
      <p>Copyright © heartin tech. All rights reserved</p>
      <p>
        | made with &#9829; by &nbsp;
        <a href="https://heartintech.solutions" style={{ color: " purple" }}>
          heartin tech.
        </a>
      </p>
    </div>
  );
};
export default Footer; */}

const Footer = () => {
    return (
        <section className="section footer bg-color py-4">
         {/*   <div className="container"> 
                <div className="row d-flex justify-content-between text-center text-md-left">
                    <div>
                             <p> © heartin tech. All Rights Reserved. Created with <a style={{ color: "#8875D1" }}> &#9829; </a> by <a href="http://heartintech.com"><img src={htlogo} className="htlogo" alt="htlogo" /></a> </p>
                           </div>
                          </div> 
                          </div>*/}
                       
                          <div >
                            <div className="footer-name style-2">
                         <h4> heartin tech</h4>
                          </div>
                               <p style={{marginTop:-380}}><a style={{ color: "#262656"}}> © heartin tech 2025.</a> All Rights Reserved. Revamped with <a style={{ color: "#8875D1" }}> &#9829; </a> by our talented Intern <a href="http://heartintech.com"> Gokulnath Venugopal</a> </p>
                            
                          </div>
                         </section>
                       
    );
}

export default Footer;